import React, { useState } from "react";
import { Controller } from "react-hook-form";
import Input from "../input";
import Icon from "../../assets/icons";

interface KycDetails {
  control: any;
  setValue: any;
  clearErrors:any
  errors:any;
  customer?: any;
}

const MAX_FILE_SIZE = 10 * 1024 * 1024; 
const ACCEPTED_FILE_TYPES = [
  "image/svg+xml",
  "application/pdf",
  "image/jpeg",
  "image/png",
];

const Kyc: React.FC<KycDetails> = ({ control, customer }) => {
  const [regCertFile, setRegCertFile] = useState<File | null>(null);
  const [validIdFile, setValidIdFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);

  return (
    <>


      <div className="items-center gap-4 mt-4">
              <Controller
                name="businessRegNumber"
                control={control}
                defaultValue={customer?.businessRegNumber}
                rules={{
                  required: "Business reg number is required",
                  
                }}
                render={({ field, fieldState }) => (
                  <Input
                    value={field.value}
                    className="w-full"
                    label="Business Registration Number"
                    placeholder="Enter Business Registration Number"
                    error={fieldState?.error?.message}
                    onChange={
                      field.onChange
                    }
                    autoComplete="off"
                  />
                )}
              />
            </div>

      <div className="items-center gap-4 mt-2">
        <label className="block text-sm font-medium mb-1">
          Business Address
        </label>
        <Controller
          name="street"
          defaultValue={customer?.street}
          control={control}
          rules={{
            required: "Street is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full mb-2"
              placeholder="Street"
              error={fieldState?.error?.message}
              onChange={field.onChange}
              autoComplete="off"
            />
          )}
        />

        <div className="flex gap-2">
          <Controller
            name="city"
            control={control}
            defaultValue={customer?.city}
            rules={{
              required: "City is required",
            }}
            render={({ field, fieldState }) => (
              <Input
                value={field.value}
                className="w-full"
                placeholder="City"
                error={fieldState?.error?.message}
                onChange={field.onChange}
                autoComplete="off"
              />
            )}
          />

          <Controller
            name="state"
            defaultValue={customer?.state}
            control={control}
            rules={{
              required: "State is required",
            }}
            render={({ field, fieldState }) => (
              <Input
                value={field.value}
                className="w-full"
                placeholder="State"
                error={fieldState?.error?.message}
                onChange={field.onChange}
                autoComplete="off"
              />
            )}
          />
        </div>
      </div>

      <div className="items-center gap-4 mt-4">
        <label className="block text-sm font-medium mb-1">
          Business Registration Certificate
        </label>
        <Controller
          name="businessCertificate"
          control={control}
          rules={{ required: "Business Certificate is required" }}
          render={({ field, fieldState }) => (
            <label className="border-2 border-dashed rounded-2xl p-6 text-center cursor-pointer block">
              <input
                type="file"
                className="hidden"
                accept=".svg,.pdf,.jpg,.jpeg,.png"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    const file = e.target.files[0];

                    if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
                      setFileError(
                        `Invalid file type. Please upload SVG, PDF, JPG, or PNG.`
                      );
                      return;
                    }

                    if (file.size > MAX_FILE_SIZE) {
                      setFileError(`File size exceeds 10MB limit.`);
                      return;
                    }
                    field.onChange(file);
                    setRegCertFile(file);
                  }
                }}
              />
              <div className="flex justify-center mb-2">
                <Icon name="upLoadIcon" />
              </div>
              {regCertFile ? (
                <>
                  <div className="text-green-600 font-medium">
                    {regCertFile.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {Math.round(regCertFile.size / 1024)} KB
                  </div>
                </>
              ) : (
                <>
                  <div className="text-green-600 font-medium">Click here</div>
                  <div className="text-xs text-gray-500">
                    to upload Business Registration Certificate
                  </div>
                </>
              )}
              <div className="text-xs text-gray-500 mt-1">
                Supported Format: SVG, PDF, JPG, PNG (10mb each)
              </div>
              {fieldState.error && (
                <div className="text-red-500 text-xs mt-1">
                  {fieldState.error.message}
                </div>
              )}
            </label>
          )}
        />
      </div>

      <div className="items-center gap-4 mt-4">
        <label className="block text-sm font-medium mb-1">
          Valid ID of Business Owner or Representative
        </label>
        <Controller
          name="businessOwnerId"
          control={control}
          rules={{ required: "Business Owner ID is required" }}
          render={({ field, fieldState }) => (
            <label className="border-2 border-dashed rounded-2xl p-6 text-center cursor-pointer block">
              <input
                type="file"
                className="hidden"
                accept=".svg,.pdf,.jpg,.jpeg,.png"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    const file = e.target.files[0];

                    if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
                      setFileError(
                        `Invalid file type. Please upload SVG, PDF, JPG, or PNG.`
                      );
                      return;
                    }

                    if (file.size > MAX_FILE_SIZE) {
                      setFileError(`File size exceeds 10MB limit.`);
                      return;
                    }

                    field.onChange(file);
                    setValidIdFile(file);
                  }
                }}
              />
              <div className="flex justify-center mb-2">
                <Icon name="upLoadIcon" />
              </div>
              {validIdFile ? (
                <>
                  <div className="text-green-600 font-medium">
                    {validIdFile.name}
                  </div>
                  <div className="text-xs text-gray-500">
                    {Math.round(validIdFile.size / 1024)} KB
                  </div>
                </>
              ) : (
                <>
                  <div className="text-green-600 font-medium">Click here</div>
                  <div className="text-xs text-gray-500">
                    to upload Valid ID of Business Owner or Representative
                  </div>
                </>
              )}
              <div className="text-xs text-gray-500 mt-1">
                Supported Format: SVG, PDF, JPG, PNG (10mb each)
              </div>
              {fieldState.error && (
                <div className="text-red-500 text-xs mt-1">
                  {fieldState.error.message}
                </div>
              )}
              {fileError && !fieldState.error && (
                <div className="text-red-500 text-xs mt-1">{fileError}</div>
              )}
            </label>
          )}
        />
      </div>
    </>
  );
};

export default Kyc;
